var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Exception',{attrs:{"type":"404","exceptionStyle":"min-height: 500px; height: 80%;"}})}
var staticRenderFns = []

export { render, staticRenderFns }